export default [
    /**
     * 个人用户
    */
    {
        path: '/user/history',
        name: '学习记录',
        component: r => require.ensure([], () => r(require('@/views/user/history')), 'user')
    },
    {
        path: '/user/setting',
        name: '通用设置',
        component: r => require.ensure([], () => r(require('@/views/user/setting')), 'user')
    },
    {
        path: '/user/address',
        name: '收货地址管理',
        component: r => require.ensure([], () => r(require('@/views/user/address')), 'user')
    },
    {
        path: '/user/history',
        name: '收货地址管理',
        component: r => require.ensure([], () => r(require('@/views/user/history')), 'user')
    },
    {
        path: '/user/mail',
        name: '证书邮寄',
        component: r => require.ensure([], () => r(require('@/views/user/mail')), 'user')
    },
    {
        path: '/user/score',
        name: '成绩查询',
        component: r => require.ensure([], () => r(require('@/views/user/score')), 'user')
    },
    {
        path: '/order',
        name: '订单中心',
        component: r => require.ensure([], () => r(require('@/views/user/order')), 'user')
    },
    {
        path: '/order/express',
        name: '快递查询',
        component: r => require.ensure([], () => r(require('@/views/user/express')), 'user')
    },
    {
        path: '/exam',
        name: '学习锦囊',
        component: r => require.ensure([], () => r(require('@/views/user/exam')), 'user')
    }

]


// WEBPACK FOOTER //
// ./src/router/routers/user.js